import { RouterProvider, createHashRouter } from 'react-router-dom'
import Home from 'pages/Home'
import About from 'pages/About'
import Services from 'pages/Services'
import Method from 'pages/Method'
import Portfolio from 'pages/Portfolio'
import Blog from 'pages/Blog'
import Contact from 'pages/Contact'
import ServiceBranding from 'pages/ServiceBranding'
import ServiceSocialMedia from 'pages/ServiceSocialMedia'
import ServicePaidTraffic from 'pages/ServicePaidTraffic'
import ServiceTech from 'pages/ServiceTech'
import ServiceAudiovisual from 'pages/ServiceAudiovisual'
import ServiceSEO from 'pages/ServiceSEO'
import PrivacyPolicy from 'pages/PrivacyPolicy'
import TermsOfUse from 'pages/TermsOfUse'
import NotFound from 'pages/NotFound'
import CookieConsent from 'components/CookieConsent'

const routes = createHashRouter([
  { path: '/', element: <Home /> },
  { path: '/sobre', element: <About /> },
  { path: '/servicos', element: <Services /> },
  { path: '/metodo', element: <Method /> },
  { path: '/portfolio', element: <Portfolio /> },
  { path: '/blog', element: <Blog /> },
  { path: '/contato', element: <Contact /> },
  { path: '/servicos/branding', element: <ServiceBranding /> },
  { path: '/servicos/midias-sociais', element: <ServiceSocialMedia /> },
  { path: '/servicos/trafego-pago', element: <ServicePaidTraffic /> },
  { path: '/servicos/tech', element: <ServiceTech /> },
  { path: '/servicos/producao-audiovisual', element: <ServiceAudiovisual /> },
  { path: '/servicos/seo', element: <ServiceSEO /> },
  { path: '/politica-de-privacidade', element: <PrivacyPolicy /> },
  { path: '/termos-de-uso', element: <TermsOfUse /> },
  { path: '*', element: <NotFound /> },
])

export default function App() {
  return (
    <>
      <RouterProvider router={routes} />
      <CookieConsent />
    </>
  )
}
